import { render } from "./bgBtns.vue?vue&type=template&id=000693a8&scoped=true"
import script from "./bgBtns.vue?vue&type=script&lang=js"
export * from "./bgBtns.vue?vue&type=script&lang=js"

import "./bgBtns.vue?vue&type=style&index=0&id=000693a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000693a8"]])

export default __exports__